"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var urlListado = {
  url: {
    'tipo-trabajo': {
      pasantia: 'practica-profesional'
    }
  },
  'url-vuelta': {
    'tipo-trabajo': {
      'practica-profesional': 'pasantia'
    }
  }
};
exports.default = urlListado;